import pauseBtn from "assets/icons/player/pause.svg";
import playBtn from "assets/icons/player/play.svg";
import { t } from "i18next";

const VideoPlayerControls = ({
  onVideoClickHandler,
  isVideoPlaying,
  progress,
  videoInfo,
  pathName,
}) => {
  return (
    <div className="video__controls user-select-none">
      <div className="d-flex flex-row justify-content-center align-items-center w-100">
        <div onClick={onVideoClickHandler} className="video__button me-2">
          <img src={isVideoPlaying ? pauseBtn : playBtn} alt="video button" />
        </div>
        <div className="progress_bar">{progress}</div>
      </div>
      <div className="d-flex flex-column w-100 px-2 ms-2">
        <div className="captions d-flex flex-row align-items-center fs-18">
          <div>
            <span className="text-uppercase">{t(pathName)}&nbsp;|&nbsp;</span>
            <span className="opacity-50">{t(videoInfo.title)}</span>
          </div>
          <div className="video__timeInfo">
            <span>{`${videoInfo?.currentTime} / ${videoInfo?.duration}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayerControls;
